import { Theme } from "@bluframe/blublocks"
import Paragraph from "components/Typography/Paragraph"
import { rgba } from "polished"
import styled from "styled-components"

const IMAGE_AND_SERVICE_LABEL_HOVER_ALPHA = 0.4
const IMAGE_AND_SERVICE_LABEL_SELECTED_ALPHA = 0.6

export const Wrapper = styled.div<{ $isSelected?: boolean }>`
  align-items: center;
  ${({ $isSelected, theme }: { $isSelected?: boolean; theme: Theme }) =>
    $isSelected
      ? `
    background: ${rgba(
      theme.palette.primary.main,
      IMAGE_AND_SERVICE_LABEL_SELECTED_ALPHA
    )};
`
      : ""} cursor: pointer;
  column-gap: 10px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  justify-items: center;
  padding: 20px 20px 10px;
  row-gap: 10px;
  transition: background 0.2s ease;

  &:hover {
    background: ${({
      $isSelected,
      theme
    }: {
      $isSelected?: boolean
      theme: Theme
    }) =>
      $isSelected
        ? ""
        : rgba(theme.palette.text.light, IMAGE_AND_SERVICE_LABEL_HOVER_ALPHA)};
  }
`

export const ArrowWrapper = styled.div`
  & button {
    padding: 6px;
  }
`

export const Main = styled.div`
  display: grid;
  justify-items: center;
  row-gap: 10px;
`

export const Image = styled.img`
  height: 200px;
  object-fit: cover;
  width: 100%;
`

export const ServiceLabel = styled(Paragraph)<{ $isSelected?: boolean }>`
  color: ${({ $isSelected, theme }: { $isSelected?: boolean; theme: Theme }) =>
    $isSelected ? theme.palette.primary.contrast : theme.palette.subtitle.main};
  font-size: 14px;
  margin: 0;
`

export const InputAndButton = styled.div`
  display: grid;
  row-gap: 10px;
`

export const TextAreaAndButton = styled.div`
  align-items: end;
  column-gap: 10px;
  display: grid;
  grid-template-columns: 1fr auto;
`

export const RegenerateIcon = styled.span<{ $isSpinning: boolean }>`
  display: inline-flex;

  ${({ $isSpinning }) =>
    $isSpinning
      ? `
    animation: rotate360 0.9s linear infinite;
  `
      : ""}

  @keyframes rotate360 {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
`
